<template>
  <el-dialog title=核销 :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="消费金额" prop="money">
          <el-input v-model="form.money" placeholder="请输入消费金额" @input ="changeInput()"></el-input>
        </el-form-item>
        <el-form-item label="分佣金额" prop="commission">
          <el-input v-model="form.commission" placeholder="分佣金额"></el-input>
          <!-- <p>{{commission}}</p> -->
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="savePrograma">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import api from "@/api.js";
  export default {
    name: "buyhexDialog",
    props: ["visible", "riziId","ratio","profit"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        dialogVisible: this.visible,
        frommate:{},
        commission:'',
        form: {
          money: '',
          commission:'',
        }
      };
    },
    created() {
      //  this.savePrograma()
    },
  //   watch: {
  //   property: {
  //     immediate: true,
  //     handler(val) {
  //       this.frommate = val
  //       // let news_ratio = 0
  //       // news_ratio = this.dialogContent.ratio
  //       this.commission = (parseFloat(this.form.money) * parseFloat(this.dialogContent.ratio) )
  //       this.commission = this.formatDecimal(this.commission,2)
  //     }
  //   },
  // },
    methods: {
      //不四舍五入，保留n位小数
   formatDecimal(num, decimal) {
        num = num.toString()
        let index = num.indexOf('.')
        if (index !== -1) {
            num = num.substring(0, decimal + index + 1)
        } else {
            num = num.substring(0)
        }
     
        return parseFloat(num).toFixed(decimal)
    },
    changeInput(){
      // let news_ratio = 0
      // news_ratio = this.dialogContent.ratio   
      this.commission = (parseFloat(this.form.money) * parseFloat(this.ratio)/100   * parseFloat(this.profit)/100) 
      this.commission = this.formatDecimal(this.commission,2)
      this.form.commission = this.commission
      // this.formdata.commission = item.shop_price*this.actratio/100;
      // console.log(2222222)
      // console.log(this.form.money)
      // console.log(this.commission)
    },
      savePrograma() {
        if (this.form.money === '') {
          this.$message({
            message: '请输入消费金额',
            type: 'warning'
          });
          return
        }
        let data = this.form
        data.data_id = this.riziId
        this.axios
            .post(api.partner_buyCheck, data)
            .then(response => {
              if (response.data.code == 0) {
                let title = '核销成功!'
                this.$message({
                  message: title
                });
                this.dialogVisible = false
                this.form.money = ''
                this.$emit('initFn');
              } else {
              }
            })
            .catch(response => {
            });
      }
    }
  };
</script>


